import React from 'react';
import {Card,CardHeader,CardContent} from '@material-ui/core';
import { lang } from '../../../config/app.config';
// import translates from '../../../translation.json';
// import { TranslationState } from '../../../store/ActionReducers/translation.actionreducer';
// import {useSelector} from 'react-redux';
import translate from '../../../translation.json';


const FBfeeds:React.FC =  ()=>{
  // const state = useSelector((state:{translation:TranslationState})=>state.translation);
  return(
    <Card>
      <CardHeader title={translate.translation[lang].youtube_links} className="card-header-primary"/>
      <CardContent className="bg-primary custom-card-body">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/BAuJYJNyJUM" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ></iframe>      
  </CardContent>
    </Card>
  );
}

export default FBfeeds;
